import { BackupRun } from '../api/types';

interface RunListProps {
  runs: BackupRun[];
  isLoading?: boolean;
}

function statusBadgeClass(status: BackupRun['status']): string {
  switch (status) {
    case 'SUCCESS':
      return 'badge badge-success';
    case 'FAILURE':
      return 'badge badge-error';
    case 'PARTIAL_FAILURE':
      return 'badge badge-warning';
    case 'RUNNING':
      return 'badge badge-info';
    default:
      return 'badge';
  }
}

export function RunList({ runs, isLoading }: RunListProps) {
  if (isLoading) {
    return <p role="status" aria-live="polite">Loading backup runs…</p>;
  }

  if (runs.length === 0) {
    return <p>No backup runs found.</p>;
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table aria-label="Backup runs">
        <thead>
          <tr>
            <th scope="col">Run ID</th>
            <th scope="col">Started</th>
            <th scope="col">Ended</th>
            <th scope="col">Status</th>
            <th scope="col">Objects</th>
            <th scope="col">Records</th>
          </tr>
        </thead>
        <tbody>
          {runs.map((run) => (
            <tr key={run.runId}>
              <td>
                <code style={{ fontSize: '0.8rem' }}>{run.runId.slice(0, 8)}</code>
              </td>
              <td>{new Date(run.startTime).toLocaleString()}</td>
              <td>{run.endTime ? new Date(run.endTime).toLocaleString() : '—'}</td>
              <td>
                <span className={statusBadgeClass(run.status)}>{run.status.replace('_', ' ')}</span>
              </td>
              <td>{run.objectCount.toLocaleString()}</td>
              <td>{run.recordCount.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
